module.exports = __webpack_public_path__ + "img/kuwait-4.dbbfe908.jpg";